<script setup lang="ts">
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import CloseIcon from "@magnit/icons/src/assets/icons/close-24.svg";

const emit = defineEmits<{
  "click:close": [];
}>();

const handleIconClick = () => {
  emit("click:close");
};
</script>

<template>
  <VButton
    rounded
    theme="invert"
    class="shop-select__close-button"
    @click="handleIconClick"
  >
    <template #icon>
      <VIcon><CloseIcon /></VIcon>
    </template>
  </VButton>
</template>

<style lang="postcss" scoped>
.shop-select__close-button {
  position: absolute !important;
  box-shadow: 0 0 10px 0 #00000026;
  z-index: 20;
  top: 16px;
  right: 16px;

  @media (--pl-viewport-from-ml) {
    top: 32px;
    right: 32px;
  }

  &:active {
    box-shadow: none;
  }
}
</style>
